export default "__VITE_ASSET__e5Z6_ZGN__"